<ion-header mode="ios" class="ion-no-border">
  <ion-toolbar>
    <button
      class="bg-transparent rounded-full cursor-pointer hover:bg-ocean-200 flex items-center my-2 justify-center text-[20px] text-gray-700 p-2 size-[40px]"
      slot="start" (click)="closeModal()"><ion-icon name="arrow-back"></ion-icon></button>
    <ion-title [hidden]="!sid">{{id ? 'Update' : 'Add'}} {{ sid?.name }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (isShowOcrLoader) {
  <div class="rocker-screen" sxWidth="full" sxHeight="full" sxCol sxAlign="center" sxDistribution="center" sxGap="10px">
    <p sxMargin="0" sxTextSize="20px" sxColor="three" sxTextAlign="center">
      Scanning your {{sid.name}}...<br />
      <br />Your ID is equally sensitive and private to both you and
      <span sxTextWeight="bold" sxTextStyle="italic">qid</span>.
    </p>
    <ion-progress-bar type="indeterminate" color="dark"></ion-progress-bar>
  </div>
  }

  <page-loader #pageLoaderComponent>

    @if (sid) {
    <div sxPadding="0 medium" sxWidth="full">
      @if (!sid.canSkipNameCheck) {
      <p sxPadding="medium" sxColor="three">
        <span sxTextWeight="bold">{{account?.name}}</span> should be clearly visible
        on your {{sid.name}}.
      </p>
      }
      @for (photo of sid.photos; track photo.name) {
      <id-image-picker [title]="photo.name" [(value)]="photo.file" [error]="photo.errorMessage"
        (valueChange)="onImageSelected()"></id-image-picker>
      }

      <!-- <div *ngIf="sid?.digilockerDocType?.length > 0" sxCol sxWidth="full">
        <div class="or-label">
          <p>OR</p>
        </div>

        <div sxPadding="22px medium" sxRadius="medium" sxBackground="light" sxBorderColor="one" sxBorderWidth="1px"
          sxCursor="pointer" (click)="onDigilockerClicked()" sxRow sxAlign="center" sxDistribution="center" sxGap="5px">
          <p sxMargin="0" sxTextSize="medium">Upload with</p>
          <img sxWidth="90px" src="assets/digilocker-logo.webp" alt="Digilocker Logo">
        </div>
      </div> -->


      <section #documentDetailsSection [hidden]="!documentOCRResult">
        <h1 sxMargin="25px 10px 0" sxColor="three" sxTextSize="medium">{{sid.name}} details</h1>
        @if (sid?.allowManualEnterIdNumber) {
        <div sxPadding="10px 0 5px">
          <super-input [label]="sid.name + ' Number'" [required]="!sid.canSkipIdNumberCheck"
            [(value)]="documentData.idNumber" [errorNote]="documentNumberErrorMessage"></super-input>
        </div>
        }

        @if (sid?.manualFields) {
        <div sxCol sxGap="5px" sxAlign="stretch">
          @for (field of documentData.manualFields; track field) {
          <super-input [label]="field.label || ''" [(value)]="field.value" [required]="field.isMandatory ?? false"
            [placeholder]="field.placeholder || ''" [type]="field.type || ''" [errorNote]="field.errorMessage ?? ''"
            (errorNoteChange)="field.errorMessage = $event" [validate]="true" [options]="field.options"></super-input>
          }
        </div>
        }

      </section>


      <div sxRow sxWidth="full" sxDistribution="center" sxAlign="center" sxColor="two" sxGap="5px"
        sxMargin="10px 0 140px">
        <ion-icon name="shield-checkmark"></ion-icon>
        <p>Secure Upload</p>
      </div>

      <page-action sxWidth="full">

        @if (!documentOCRResult) {
        <super-button [action]="autofill" [showError]="true" iconEnd="chevron-forward">Upload
        </super-button>
        }

        @if (documentOCRResult) {
        <super-button [action]="verifyUpload" [showError]="true" iconEnd="chevron-forward">{{id ? 'Update' :
          'Save'}}</super-button>
        }

      </page-action>


    </div>
    }


  </page-loader>
</ion-content>

<ion-modal #digilockerModal [showBackdrop]="true" [backdropDismiss]="false" [initialBreakpoint]="0.6"
  [breakpoints]="[0, 0.6]">
  <ng-template>
    <ion-content>
      <div sxPadding="medium" sxMargin="15px 0 0">
        <div sxPadding="medium" sxRadius="medium" sxBackground="light" sxBorderWidth="1px" sxBorderColor="one">
          <!-- <digilocker #digilockerComponent [sid]="sid"></digilocker> -->
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>